import styled from 'styled-components';
import {
  IScheduleFieldsFragment,
  ISlackDestinationFieldsFragment,
  Maybe,
} from '../../../../utils/apollo/graphqlSchema';
import { isNil } from 'lodash';
import SlackDestinationRecipient from './SlackDestinationRecipient';
import EmailRecipients from './EmailRecipients';

interface IProps {
  recipients: IScheduleFieldsFragment['recipients'];
  emailList: IScheduleFieldsFragment['emailList'];
  slackDestination: Maybe<ISlackDestinationFieldsFragment>;
}

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 20px;
  align-items: center;
  column-gap: 6px;
`;

const ScheduleRecipients = ({
  recipients,
  emailList,
  slackDestination,
}: IProps) => {
  return (
    <Container>
      {!isNil(slackDestination) && (
        <SlackDestinationRecipient slackDestination={slackDestination} />
      )}
      {emailList.length > 0 && (
        <EmailRecipients recipients={recipients} emailList={emailList} />
      )}
    </Container>
  );
};

export default ScheduleRecipients;
